import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEventFulfillmentDataByFulfillmentStepQueryVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
}>;


export type GetEventFulfillmentDataByFulfillmentStepQuery = { __typename?: 'Query', getEventFulfillmentDataByFulfillmentStep: { __typename?: 'EventFulfillmentDataByFulfillmentStep', event_accounts: Array<{ __typename?: 'EventAccountInfo', id: string, name?: string | null }>, container_types: Array<{ __typename?: 'ContainerType', id: number, name: string, image?: string | null, image_url?: string | null, segment?: Types.ContainerTypeSegment | null, size_helper?: string | null, packing_unit?: number | null, color_hex_code?: string | null }>, stock_entries: Array<{ __typename?: 'EventFulfillmentStepEntry', event_account_id: string, container_type_id: number, ordered?: number | null, delivered: number, in_stock: number, handed_out: number, received_dirty: number, received_sealed: number, cleaned: number }>, container_station_returns: Array<{ __typename?: 'ContainerStationReturn', type: string, event_account_id: string, count: number, image_url?: string | null, name?: string | null, color_hex_code?: string | null }> } };


export const GetEventFulfillmentDataByFulfillmentStepDocument = gql`
    query GetEventFulfillmentDataByFulfillmentStep($event_id: ID!) {
  getEventFulfillmentDataByFulfillmentStep(event_id: $event_id) {
    event_accounts {
      id
      name
    }
    container_types {
      id
      name
      image
      image_url
      segment
      size_helper
      packing_unit
      color_hex_code
    }
    stock_entries {
      event_account_id
      container_type_id
      ordered
      delivered
      in_stock
      handed_out
      received_dirty
      received_sealed
      cleaned
    }
    container_station_returns {
      type
      event_account_id
      count
      image_url
      name
      color_hex_code
    }
  }
}
    `;

/**
 * __useGetEventFulfillmentDataByFulfillmentStepQuery__
 *
 * To run a query within a React component, call `useGetEventFulfillmentDataByFulfillmentStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventFulfillmentDataByFulfillmentStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventFulfillmentDataByFulfillmentStepQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetEventFulfillmentDataByFulfillmentStepQuery(baseOptions: Apollo.QueryHookOptions<GetEventFulfillmentDataByFulfillmentStepQuery, GetEventFulfillmentDataByFulfillmentStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventFulfillmentDataByFulfillmentStepQuery, GetEventFulfillmentDataByFulfillmentStepQueryVariables>(GetEventFulfillmentDataByFulfillmentStepDocument, options);
      }
export function useGetEventFulfillmentDataByFulfillmentStepLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventFulfillmentDataByFulfillmentStepQuery, GetEventFulfillmentDataByFulfillmentStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventFulfillmentDataByFulfillmentStepQuery, GetEventFulfillmentDataByFulfillmentStepQueryVariables>(GetEventFulfillmentDataByFulfillmentStepDocument, options);
        }
export type GetEventFulfillmentDataByFulfillmentStepQueryHookResult = ReturnType<typeof useGetEventFulfillmentDataByFulfillmentStepQuery>;
export type GetEventFulfillmentDataByFulfillmentStepLazyQueryHookResult = ReturnType<typeof useGetEventFulfillmentDataByFulfillmentStepLazyQuery>;
export type GetEventFulfillmentDataByFulfillmentStepQueryResult = Apollo.QueryResult<GetEventFulfillmentDataByFulfillmentStepQuery, GetEventFulfillmentDataByFulfillmentStepQueryVariables>;